import React from "react";
import {
  Card,
  Form,
  Row,
  Col,
  DatePicker,
  Input,
  Select,
  Button,
  Space
} from "antd";
import {
  SearchOutlined,
  ClearOutlined,
  FilterOutlined
} from "@ant-design/icons";

const { RangePicker } = DatePicker;
const { Option } = Select;

const EcommerceOrderFilter = ({ onFilter, loading }) => {
  const [form] = Form.useForm();

  const handleFilter = (values) => {
    const filters = {};

    // Date range handling
    if (values.dateRange && values.dateRange.length === 2) {
      filters.start_date = values.dateRange[0].format("YYYY-MM-DD");
      filters.end_date = values.dateRange[1].format("YYYY-MM-DD");
    }

    // Combined search filter (phone or order number)
    if (values.search && values.search.trim()) {
      filters.search = values.search.trim();
    }

    // Status filter
    if (values.order_status) {
      filters.order_status = values.order_status;
    }

    if (values.ecommerce_status) {
      filters.ecommerce_status = values.ecommerce_status;
    }

    // Confirm filter
    if (values.confirm !== undefined && values.confirm !== null && values.confirm !== "all") {
      filters.confirm = values.confirm === "true";
    }

    onFilter(filters);
  };

  const handleReset = () => {
    form.resetFields();
    onFilter({});
  };

  return (
    <Card 
      style={{ marginBottom: 5 }}
    >
      <Form
        form={form}
        layout="horizontal"
        onFinish={handleFilter}
      >
        <Row gutter={16}>
          <Col span={4}>
            <Form.Item
              name="search"
            >
              <Input
                placeholder="Phone or Order Number"
                allowClear
              />
            </Form.Item>
          </Col>

          <Col span={6}>
            <Form.Item
            //   label="Date Range"
              name="dateRange"
            >
              <RangePicker
                style={{ width: "100%" }}
                format="YYYY-MM-DD"
                placeholder={["Start Date", "End Date"]}
              />
            </Form.Item>
          </Col>

          <Col span={4}>
            <Form.Item
            //   label="Order Status"
              name="ecommerce_status"
            >
              <Select
                placeholder="Select status"
                allowClear
              >
                <Option value="Ecommerce Pending">Ecommerce Pending</Option>
                <Option value="Ecommerce Confirm">Ecommerce Confirm</Option>
                <Option value="Ecommerce Rejected">Ecommerce Rejected</Option>
                <Option value="Partially Confirmed">Partially Confirmed</Option>
              </Select>
            </Form.Item>
          </Col>

          <Col span={3}>
            <Form.Item
            //   label="Confirmed"
              name="confirm"
            >
              <Select
                placeholder="Confirmation"
                allowClear
              >
                <Option value="all">All</Option>
                <Option value="true">Yes</Option>
                <Option value="false">No</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={6}>
            <Space>
              <Button
                type="primary"
                htmlType="submit"
                icon={<SearchOutlined />}
                loading={loading}
              >
                Apply Filters
              </Button>
              <Button
                icon={<ClearOutlined />}
                onClick={handleReset}
              >
                Clear Filters
              </Button>
            </Space>
          </Col>
        </Row>

        
      </Form>
    </Card>
  );
};

export default EcommerceOrderFilter;